import { LocalScriptContentProviderOptions, LocalScriptContentProvider } from "../../../typings/local-script-content-provider";

export class WidgetScriptContentProvider implements LocalScriptContentProvider {

    constructor(private readonly elementName: string) {
    }

    public getScriptTextContent(options: LocalScriptContentProviderOptions): string {
        const preparedWidgetId = options.elementId.replace("-", "_");
        return `
            window.__timers = window.__timers || {};

            window.clearTimeout(window.__timers.${preparedWidgetId});

            window.__timers.${preparedWidgetId} = window.setTimeout(() => {
                const initializeWidget = () => {
                    const widget_${preparedWidgetId} = new window.__truSites.${this.elementName}("${options.elementId}");
                    widget_${preparedWidgetId}.render();
                };

                if (window.__truSites?.${this.elementName}) {
                    if (document.readyState === "interactive" || document.readyState === "complete") {
                        initializeWidget();
                    } else {
                        document.addEventListener("DOMContentLoaded", initializeWidget, { once: true });
                    }
                } else {
                    const script_${preparedWidgetId} = document.getElementById("${options.commonScriptId}");
                    script_${preparedWidgetId}?.addEventListener("load", initializeWidget, { once: true });
                }
            }, 30);
        `;
    }

}
